import { Badge } from '@common/ui/Badge';
import { Button } from '@common/ui/buttons/Button';
import { TextArea } from '@common/ui/inputs/TextArea';

import { SuperlikeOverlay } from '../SuperlikeOverlay';
import { SUPERLIKE_MESSAGE_MAX_LENGTH } from '../utils';
import styles from './SuperlikeSheet.module.scss';

export type SuperlikeSheetProps = {
  /** The card's name, as it is (nominative, no declension). */
  name: string;
  /** Superlikes left today; the badge hides while it is not known. */
  remaining: number | undefined;
  message: string;
  /** The inline refusal of the message (a 422 or the client's check). */
  messageError?: string;
  isSending: boolean;
  onMessageChange: (message: string) => void;
  onSend: () => void;
  onClose: () => void;
};

/**
 * The superlike's sheet (board 1.3): who will see it, today's remaining
 * count, an optional message of up to 300 characters, send and cancel.
 */
export const SuperlikeSheet = ({
  name,
  remaining,
  message,
  messageError,
  isSending,
  onMessageChange,
  onSend,
  onClose,
}: SuperlikeSheetProps) => (
  <SuperlikeOverlay
    testId="superlike-sheet"
    label="Суперлайк"
    icon="/icons/3d-icons/likes.png"
    onClose={onClose}
    buttons={[
      <Button
        testId="superlike-sheet-send-button"
        variant="premiumPrimary"
        size={1000}
        loading={isSending}
        disabled={isSending}
        onClick={onSend}
      >
        Отправить суперлайк
      </Button>,
      <Button
        testId="superlike-sheet-cancel-button"
        variant="actionSecondary"
        size={1000}
        onClick={onClose}
      >
        Отмена
      </Button>,
    ]}
  >
    <div className={styles.text}>
      <h2 className={styles.title}>Суперлайк</h2>
      <p className={styles.subtitle} data-test-id="superlike-sheet-subtitle">
        <span className="ym-hide-content">{name}</span> увидит вашу анкету
        первой. Можно добавить пару слов
      </p>
      {remaining !== undefined && (
        <Badge
          testId="superlike-sheet-remaining"
          color="neutralSecondary"
          text={`Осталось сегодня: ${remaining}`}
        />
      )}
    </div>

    <div className={styles.field} data-test-id="superlike-sheet-message">
      <TextArea
        className="ym-disable-keys"
        placeholder="Сообщение · по желанию"
        maxLength={SUPERLIKE_MESSAGE_MAX_LENGTH}
        rows={2}
        value={message}
        description={`${message.length} / ${SUPERLIKE_MESSAGE_MAX_LENGTH}`}
        error={messageError}
        onChange={(event) => onMessageChange(event.target.value)}
      />
    </div>
  </SuperlikeOverlay>
);
